// extracted by mini-css-extract-plugin
export default {"container":"adminServices_container__BfRcD","card_container":"adminServices_card_container__wjQbz","card_wrapper":"adminServices_card_wrapper__06zIA"};